import React, { useEffect, useMemo, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import debounce from "lodash/debounce";

import Swal from "sweetalert2";
import moment from "moment";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sendOtp, verifyOtp } from "../../../redux/client/clientSlice"; // ✅ path adjust kar lena
import socket from "../../../context/socket";

const AuthenticationModal = ({ isConnected, show, setShowAuthModal, hasNomineeDetailsData, roomId, openApplicantForm, noNominate, setNoNominate, isVerifySuccess, setIsVerifySuccess }) => {
  const nomineedata = hasNomineeDetailsData?.data?.[0];
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const { clientData } = useSelector((state) => state.client);
  // console.log('clientData', clientData.pan_no);
  const dispatch = useDispatch();



  useEffect(() => {
    const handleExecute = (data) => {
      console.log("execute data received:", data, data?.data?.verifyOtp);

      if (data?.data?.verifyOtp) {
        openApplicantForm();
      }
    };

    socket.on("execute", handleExecute);

    return () => {
      socket.off("execute", handleExecute);
    };
  }, []);



  const onHide = () => {
    setShowAuthModal(false)
    setOtpSent(false);

  }

  const requestOtp = async () => {
    if (!clientData?._id) {
      Swal.fire("Client ID not found!", "", "error");
      return;
    }

    const hasContactDetailsData = clientData?.kyc_doc && clientData?.kyc_doc.find((doc) => doc.doctype === "contact_details");
    const mobileData = hasContactDetailsData?.data?.[0]?.mobile || hasContactDetailsData?.data?.[0]?.mobile_no || clientData?.mobile;
    console.log('mobileData', hasContactDetailsData?.data?.[0]?.mobile || hasContactDetailsData?.data?.[0]?.mobile_no || clientData?.mobile);

    const payload = {
      clientId: clientData._id,
      mobile: mobileData,
    }
    try {
      setOtpSent(true);
      await dispatch(sendOtp(payload)).unwrap();

      socket.emit("gateway",
        {
          room: roomId,
          data: {
            otpSent: true,
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "OTP Sent",
        text: `OTP has been sent to mobile number: ${mobileData || 'registered number'}`,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
    } catch (err) {
      setOtpSent(false);
      socket.emit("gateway",
        {
          room: roomId,
          data: {
            otpSent: false,
          },
        }
      );
      Swal.fire({
        icon: "error",
        title: "Failed to send OTP",
        text: err || "Something went wrong",
      });
    }
  };




  useEffect(() => {
    const handleExecute = (payload) => {
      console.log("gatewayy data received:", payload);

      // OTP Sent flag (unchanged)
      if (typeof payload?.data?.otpSent === "boolean") {
        setOtpSent(payload.data.otpSent);
      }
    };


    socket.on("gateway", handleExecute);

    return () => {
      socket.off("gateway", handleExecute);
    };
  }, []);
  useEffect(() => {
    const handleExecute = (payload) => {
      console.log("message_to data received:", payload);
      // OPTION 3: Receive OTP value
      if (typeof payload?.data?.otp === "string") {
        setOtp(payload.data.otp);
      }
    };


    socket.on("message_to", handleExecute);

    return () => {
      socket.off("message_to", handleExecute);
    };
  }, []);


  

  const handleVerifyOtp = async () => {
    if (!clientData?._id || !otp) {
      Swal.fire({
        icon: "error",
        title: "Missing data",
        text: "Client ID or OTP is missing",
      });
      return;
    }

    try {
      await dispatch(verifyOtp({ clientId: clientData._id, otp })).unwrap();

      const swalInstance = Swal.fire({
        icon: "success",
        text: "OTP Verified Successfully",
        title: "Success",
        showConfirmButton: false,
      });

      setTimeout(() => {
        Swal.close(); // ✅ force close
        onHide();
        setOtp("");
        setOtpSent(false);
        setIsVerifySuccess(true);
        openApplicantForm();
      }, 1200); // 1.2 sec delay
    } catch (error) {
      console.error(error);
    }

  };


  const emitOtp =useMemo(
  () =>
    debounce((value) => {
      socket.emit("message_to", {
        room: roomId,
        data: { otp: value },
      });
    }, 400),
  [roomId]
);

  return (
    <Modal show={show} onHide={onHide} size="md">
      <Modal.Header closeButton style={{ backgroundColor: "#c7e69b" }}>
        <Modal.Title>Authentication</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="panNo">
            <Form.Label>PAN No</Form.Label>
            <Form.Control type="text" value={clientData.pan_no} disabled />
          </Form.Group>

          <Form.Group className="mb-3" controlId="noNominateCheckbox">
            <Form.Check
              type="checkbox"
              label="I don't wish to Nominate"
              checked={noNominate}
              onChange={(e) => setNoNominate(e.target.checked)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="nomineeName">
            <Form.Label>Nominee Name</Form.Label>
            <Form.Control type="text"
              value={noNominate ? "" : nomineedata?.nominee_name || ""}
              disabled />
          </Form.Group>

          <Form.Group className="mb-3" controlId="birthDate">
            <Form.Label>Birth Date</Form.Label>
            <Form.Control
              type="text"
              disabled
              value={
                noNominate
                  ? ""
                  : nomineedata?.nominee_dob
                    ? moment(nomineedata?.nominee_dob)?.format("DD-MM-YYYY")
                    : ""
              }
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="relation">
            <Form.Label>Relation</Form.Label>
            <Form.Control
              type="text"
              disabled
              value={noNominate ? "" : nomineedata?.nominee_relation || ""}
            />
          </Form.Group>

          {otpSent && (
            <Form.Group className="mb-3" controlId="otp">
              <Form.Label>Enter OTP</Form.Label>
               <Form.Control
                value={otp}
                onChange={(e) => {
                  const value = e.target.value;
                  setOtp(value);
                  emitOtp(value);
                }}
              />
            </Form.Group>
          )}

          <div>
            <small style={{ fontSize: '10px' }}>
              <span className="text-danger" style={{ fontSize: '12px' }}>*</span>
              This OTP will enable authentication of Nominee and enablement of your account on the BSE Star Mutual Fund platform
            </small>
          </div>

          <div className="text-end">
            {otpSent ? (
              <>
                <Button variant="secondary" onClick={requestOtp} className="me-2">
                  Resend OTP
                </Button>
                <Button variant="success" onClick={handleVerifyOtp}>
                  Verify
                </Button>
              </>
            ) : (
              <Button variant="success" onClick={requestOtp}>
                Authenticate
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AuthenticationModal;
